import * as React from "react";

const SvgComponent = () => (
  // <svg width={21} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  //   <path
  //     d="M20.315 1.96a8.348 8.348 0 0 1-2.398.645A4.152 4.152 0 0 0 19.748.31a8.219 8.219 0 0 1-2.641 1.006A4.152 4.152 0 0 0 14.065 0a4.162 4.162 0 0 0-4.163 4.165c0 .322.04.645.103.955A11.83 11.83 0 0 1 1.42.762a4.134 4.134 0 0 0-.567 2.102c0 1.445.735 2.72 1.856 3.469a4.2 4.2 0 0 1-1.882-.53v.051a4.164 4.164 0 0 0 3.337 4.087c-.358.093-.726.141-1.096.142-.271 0-.527-.027-.786-.063a4.17 4.17 0 0 0 3.891 2.888 8.344 8.344 0 0 1-5.168 1.78c-.35 0-.672-.013-1.006-.052a11.788 11.788 0 0 0 6.394 1.868c7.656 0 11.846-6.343 11.846-11.848 0-.18 0-.362-.012-.542a8.965 8.965 0 0 0 2.087-2.154Z"
  //     fill="#282828"
  //   />
  // </svg>
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 32 32">
    <path d="M 4.0175781 4 L 13.091797 17.609375 L 4.3359375 28 L 6.9511719 28 L 14.246094 19.34375 L 20.017578 28 L 20.552734 28 L 28.015625 28 L 18.712891 14.042969 L 27.175781 4 L 24.560547 4 L 17.558594 12.310547 L 12.017578 4 L 4.0175781 4 z M 7.7558594 6 L 10.947266 6 L 24.279297 26 L 21.087891 26 L 7.7558594 6 z"></path>
  </svg>
);

export default SvgComponent;
